import * as React from "react";
const SvgFiRrReservationSmartphone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-reservation-smartphone_svg__a)">
      <path
        fill="#062147"
        d="M23.971 19.057a1 1 0 0 1-.997.935q-.033 0-.066-.002a5.01 5.01 0 0 1-4.354-3.239l-1.401-3.75h-5.045c-1.516 0-2.834-1.076-3.066-2.503a3.01 3.01 0 0 1 .674-2.439 3 3 0 0 1 2.286-1.057h7.563l-.821-1.04a2.995 2.995 0 0 1 4.439-4.021l.538.558c.18.186.28.435.28.694 0 .9-1.095 1.342-1.72.694l-.548-.568a1.001 1.001 0 0 0-1.464 1.364L22.42 7.38a1.002 1.002 0 0 1-.782 1.623H12a1 1 0 0 0-.762.353c-.193.228-.272.52-.224.823.076.462.556.825 1.093.825h5.739a1 1 0 0 1 .937.65l1.644 4.4a3 3 0 0 0 2.612 1.943c.551.037.969.513.933 1.063zM16 17v2c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h6a5 5 0 0 1 4.842 3.75 1 1 0 1 1-1.937.499 3 3 0 0 0-2.906-2.25h-6c-1.654 0-3 1.346-3 3v11h13a1 1 0 0 1 1 1zm-2 1H2v1c0 1.654 1.346 3 3 3h6c1.654 0 3-1.346 3-3zm-5 3H7a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-reservation-smartphone_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrReservationSmartphone;
